import Cookies from 'js-cookie'
import {
  getOpenEmbedModeFlag,
  setOpenEmbedModeFlag,
  clearOpenEmbedModeFlag
} from '@/utils/openEmbedSession'
import { LAYOUT_PREVIEW_DESKTOP, LAYOUT_PREVIEW_MOBILE } from '@/utils/layoutPreviewMode'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    /** 超级管理员 PC 端布局预览：desktop | mobile，默认 PC */
    layoutPreviewMode: LAYOUT_PREVIEW_DESKTOP,
    /** Open API 免登嵌入：隐藏侧栏与顶栏，供合作方 iframe 内嵌业务页 */
    openEmbedMode: getOpenEmbedModeFlag()
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_OPEN_EMBED_MODE: (state, enabled) => {
      state.openEmbedMode = !!enabled
      if (enabled) {
        setOpenEmbedModeFlag()
      } else {
        clearOpenEmbedModeFlag()
      }
    },
    SET_LAYOUT_PREVIEW_MODE: (state, mode) => {
      state.layoutPreviewMode =
        mode === LAYOUT_PREVIEW_MOBILE ? LAYOUT_PREVIEW_MOBILE : LAYOUT_PREVIEW_DESKTOP
    }
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    EnableOpenEmbedMode({ commit }) {
      commit('SET_OPEN_EMBED_MODE', true)
    },
    DisableOpenEmbedMode({ commit }) {
      commit('SET_OPEN_EMBED_MODE', false)
    },
    SetLayoutPreviewMode({ commit, dispatch }, mode) {
      const next =
        mode === LAYOUT_PREVIEW_MOBILE ? LAYOUT_PREVIEW_MOBILE : LAYOUT_PREVIEW_DESKTOP
      commit('SET_LAYOUT_PREVIEW_MODE', next)
      if (next === LAYOUT_PREVIEW_MOBILE) {
        dispatch('CloseSideBar', { withoutAnimation: true })
      }
    },
    ToggleLayoutPreview({ state, dispatch }) {
      const next =
        state.layoutPreviewMode === LAYOUT_PREVIEW_MOBILE
          ? LAYOUT_PREVIEW_DESKTOP
          : LAYOUT_PREVIEW_MOBILE
      dispatch('SetLayoutPreviewMode', next)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js